if (!customElements.get('discount-input')) {
    class DiscountInput extends HTMLElement {
        constructor(){
            super();
        }
        connectedCallback(){
            this.submit = this.querySelector('[type="button"]');
            this.input = this.querySelector('[type="text"]');
            this.error = this.querySelector('#Error');

            const activeDiscountAttr = this.dataset.activeDiscount;
            if (activeDiscountAttr) this.addedDiscount = new Set(activeDiscountAttr.split(','));
            else this.addedDiscount = new Set();

            const cookieCart = getCookie('cart');
            this.cartId = cookieCart ? 'gid://shopify/Cart/' + cookieCart : null;

            this.successTimeout = null;
            this.errorTimeout = null;

            this.bindedPreventFormSubmit = this.preventFormSubmit.bind(this);
            this.bindedHandleSubmitCode = this.handleSubmitCode.bind(this);
            this.bindedHandleCartChanged = this.handleCartChanged.bind(this);

            this.input.addEventListener('keydown',this.bindedPreventFormSubmit);
            this.submit.addEventListener('click', this.bindedHandleSubmitCode);
            document.addEventListener('theme:cart:change', this.bindedHandleCartChanged);
        }
        async handleSubmitCode(){
            this.toggleSubmitButton(true);
            this.addedDiscount.add(this.input.value);

            try{
                const response = await executeQuery(this.getQuery(),{
                    cartId: this.cartId,
                    discountCodes: Array.from(this.addedDiscount)
                },'2025-01');

                const { userErrors, warnings, cart } = response?.data?.cartDiscountCodesUpdate;
                const discountsErrors = cart.discountCodes.filter( d => d.code === this.input.value && !d.applicable);

                if (userErrors.length > 0 || warnings.length > 0 || discountsErrors.length > 0){
                    this.addedDiscount.delete(this.input.value);
                    this.toggleError();
                    this.toggleSubmitButton(false);
                }
                else{
                    this.toggleSuccess(true);
                    window.cart.getCart();
                    this.toggleSubmitButton(false);
                }
            }
            catch(error){
                console.error('Apply discount error',error);
                this.toggleError();
                this.toggleSubmitButton(false);
            }

        }

        handleCartChanged(event){
            const {cart} = event.detail;
            this.addedDiscount = new Set();
            if (cart && cart?.cart_level_discount_applications) {
                cart.cart_level_discount_applications.forEach((discount) => {
                    this.addedDiscount.add(discount.title)
                })
            }
            if (cart.items) {
                cart.items.forEach(item => {
                    if (item.discounts && Array.isArray(item.discounts)) {
                        item.discounts.forEach(discount => {
                            if (discount.title) {
                                this.addedDiscount.add(discount.title);
                            }
                        });
                    }
                });
            }
        }

        preventFormSubmit(event){
            if(event.key === 'Enter'){
                event.preventDefault();
                this.submit.click();
            }
        }

        toggleSubmitButton(active){
            if (active) {
                this.submit.classList.add('is-loading');
                this.submit.classList.add('is-disabled');
            }
            else {
                this.submit.classList.remove('is-loading');
                this.submit.classList.remove('is-disabled');
            }
        }

        toggleSuccess(){
            this.submit.classList.add('is-added');
            this.submit.classList.remove('is-loading');
            if (this.successTimeout) clearTimeout(this.successTimeout);

            this.successTimeout = setTimeout(()=>{
                this.submit.classList.remove('is-added');
                this.input.value = '';
            },1500)
        }

        toggleError(){
            this.error.classList.remove('is-hidden');
            if (this.errorTimeout) clearTimeout(this.errorTimeout);

            this.errorTimeout = setTimeout(()=>{
                this.error.classList.add('is-hidden');
            },2500)
        }

        getQuery(){
            return `
                mutation cartDiscountCodesUpdate($cartId: ID!, $discountCodes: [String!]) {
                    cartDiscountCodesUpdate(cartId: $cartId, discountCodes: $discountCodes) {
                        cart{
                            id
                            discountCodes{
                                code
                                applicable
                            }            
                        }
                        userErrors{
                            field
                            message
                        }
                        warnings{
                            code
                            message
                        }
                    } 
                }
            `;
        }
    }
    customElements.define('discount-input', DiscountInput);
}